import React, { useState } from "react";
import { useSelector,useDispatch } from "react-redux";
import "./AdminPriceList.css";
import { Form, Link, useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Swal from "sweetalert2";
import { Timestamp } from "firebase/firestore";
import Button from "react-bootstrap/Button";
import { createMaterials } from "../../redux/addMaterialReducer";
import axios from "axios";





function AdminPriceList() {

  const navigation = useNavigate();
    const dispatch = useDispatch();

  const [itemShow, setItemShow] = useState(false);


  const [addNewItem, setAddNewItem] = useState([{ label: '', value: '' }]);
  console.log("addNewItem",addNewItem);


  // Extracting data from Redux
  const kitchenThingsData = useSelector((state) => state.kitchenThings?.kitchenThingsData || []);
  const bedroomThingsData = useSelector((state) => state.bedroomThings?.bedroomThingsData || []);
  const foyerThingsData = useSelector((state) => state.foyerThings?.foyerThingsData || []);
  const livingThingsData = useSelector((state) => state.livingThings?.livingThingsData || []);
  const otherWorkThingsData = useSelector((state) => state.OtherWorkThings?.otherWorkThingsData || []);
  const looseThingsData = useSelector((state) => state.looseThings?.looseThingsData || []);
  const accessoriesThingsData = useSelector((state) => state.accessories?.accessoriesThingsData || []);
  console.log(kitchenThingsData);
  // console.log(foyerThingsData);

  // Array of room objects with associated data
  const roomData = [
    { name: "Kitchen", data: kitchenThingsData },
    { name: "Bedroom", data: bedroomThingsData },
    { name: "Foyer", data: foyerThingsData },
    { name: "Living", data: livingThingsData },
    { name: "Other Work", data: otherWorkThingsData },
    { name: "Loose Items", data: looseThingsData },
    { name: "Accessories", data: accessoriesThingsData },
  ];


  const AddNewItem = (event) => {
    event.preventDefault();
    setAddNewItem([...addNewItem, { label: '', value: '' }]);
  };

  const handleFieldchange = (value, index, fieldName) => {
    console.log("value", value);
    console.log("index", index);
    console.log("fieldName", fieldName);
    const updatedFields = [...addNewItem];
    updatedFields[index][fieldName] = value;
    console.log(updatedFields);
    setAddNewItem(updatedFields);
  }

  const handleRemoveField = (index) => {
    const updatedFields = [...addNewItem];
    updatedFields.splice(index, 1);
    setAddNewItem(updatedFields);
  }


  const [selectedRoomTypes, setSelectedRoomTypes] = useState([]);
  console.log("selectedRoomTypes",selectedRoomTypes);

  const [materialFields, setMaterialFields] = useState([{ label: '', value: '' }]);
  const [roomTypeMeasurement, setRoomTypeMeasurement] = useState("");
  const [roomTypeWood, setRoomTypeWood] = useState("");
  const [roomTypeMaterialName, setRoomTypeMaterialName] = useState("");
  const [woodwork, setWoodwork] = useState(''); 
  console.log("roomTypeWood",roomTypeWood);



  const handleRoomTypeChange = (e) => {
    const options = Array.from(e.target.selectedOptions, option => option.value);
    setSelectedRoomTypes(options);  // Updates the state with selected values
  };
  // Handle removal of a selected room type
  const handleRemoveRoomType = (roomType) => {
    setSelectedRoomTypes(prev => prev.filter(item => item !== roomType));  // Remove selected room type from state
  };

  const handleAddField = () => {
    setMaterialFields([...materialFields, { label: '', value: '' }]);
  };

  const handleRemoveField1 = (index) => {
    const updatedFields = [...materialFields];
    updatedFields.splice(index, 1);
    setMaterialFields(updatedFields);
  };

  const handleFieldChange = (value, index, fieldName) => {
    const updatedFields = [...materialFields];
    updatedFields[index][fieldName] = value;
    setMaterialFields(updatedFields);
  };


  const handleAddingRoomMaterial = async () => {

    
    if (!roomTypeMaterialName || !roomTypeMeasurement || selectedRoomTypes.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Missing Fields",
        text: "Please fill all required fields before adding!",
      });
      return;
    }
  
    Swal.fire({
      title: "Adding Materials...",
      text: "Please wait while we save the data.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  
    try {
      for (const item of selectedRoomTypes) {
        const allData = {
          material: addNewItem,
          name: roomTypeMaterialName,
          measurement: roomTypeMeasurement,
          table: item,
          type:woodwork,
          timestamp: new Date(), 
        };
        console.log("Dispatching:", allData);
        await axios.post('https://us-central1-fabdiz-quote.cloudfunctions.net/api/materials', allData);
      }
  
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Materials added successfully!",
        timer: 2000,
        showConfirmButton: false,
      });
  
      setSelectedRoomTypes([]);
      setRoomTypeMaterialName("");
      setRoomTypeMeasurement("");
      setAddNewItem([{ label: "", value: "" }]);
      setItemShow(false);
      window.location.reload()
      
    } catch (error) {
      console.error("Error adding materials:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Something went wrong. Please try again.",
      });
    }
  };
  
  


  return (
    <div>


      {/* Edit Item Modal */}
      <Modal show={itemShow} size="lg" centered>
        <Modal.Header closeButton onClick={() => setItemShow(false)}>
          <Modal.Title>Add New Item</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="mb-3">
              <label htmlFor="roomType" className="form-label"
              style={{
                fontWeight: 'bold',
              }}
              >Room Type</label>
              <select
                id="roomType"
                className="form-select"
                multiple
                value={selectedRoomTypes}
                onChange={handleRoomTypeChange}
                aria-label="Room Type Select"
                required
              >
                <option value="kitchen">Kitchen</option>
                <option value="Bedroom">Bedroom</option>
                <option value="Foyer">Foyer</option>
                <option value="LivingRoom">Living Room</option>
                <option value="OtherWorks">Other Works</option>
                <option value="LooseFurniture">Loose Furniture</option>
                <option value="Accessories">Accessories</option>
              </select>

              {/* Display selected room types */}
              {selectedRoomTypes.length > 0 && <div style={{
                marginTop: 30
              }}>
                <h5>Selected Room Types:</h5>
                <ul style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: 30,
                }} >
                  {selectedRoomTypes.map((roomType, index) => (
                    <div key={index} className="selected-item" style={{
                      backgroundColor: 'lightgreen',
                      padding: '0.5rem',
                      borderRadius: '5px',
                    }}>
                      <span>{roomType}</span>
                      {/* Cross button to remove selected room type */}
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => handleRemoveRoomType(roomType)}
                        style={{ marginLeft: '10px', padding: '0 5px' }}
                      >
                        <i className="bi bi-x-circle-fill" style={{ fontSize: '1rem' }}></i> {/* Cross icon */}
                      </Button>
                    </div>
                  ))}
                </ul>
              </div>}
              <hr />
              <div class="mb-3">
                <label for="roomTypeMeasurement"style={{
                fontWeight: 'bold',
              }} class="form-label">Measurement</label>
                <select value={roomTypeMeasurement} onChange={(e) => { setRoomTypeMeasurement(e.currentTarget.value) }}  id="roomTypeMeasurement" class="form-select" required>
                  <option value="">Select Measurement Type</option>
                  <option value="area">Area</option>
                  <option value="width">Width & Height</option>
                  <option value="rft">RFT</option>
                  <option value="qty">Quantity</option>
                  <option value="length">Width & Length</option>
                  <option value="selection">Selection</option>
                </select>
              </div>
              <hr />
              <div class="mb-3">
                <label for="roomTypeMeasurement" style={{
                fontWeight: 'bold',
              }} class="form-label"> wood work type</label>
                <select value={woodwork} onChange={(e) => { setWoodwork(e.currentTarget.value) }}  id="roomTypeMeasurement" class="form-select" required>
                  <option value="">Select wood work Type</option>
                  <option value="woodwork"> wood work</option>
                  <option value="">none  wood work</option>
                </select>
              </div>
              <hr />
            </div>
            <div className="AddNewUnitName">
              <h6 style={{
                fontWeight: 'bold',
              }}>Item Name</h6>
              <input
               value={roomTypeMaterialName}
               onChange={(e) => { setRoomTypeMaterialName(e.target.value) }}
                className="AddNewUnitplace"
                type="text"
                placeholder="Item Name"
                aria-label="Unit Name"
              />
            </div>
            <hr />
            <div className="AddingFeelds">
              <p>Add Materials options</p>
              <div  className="AddingFeelds1">
                <p>Price</p>
                {/* Add Material Field Button */}
                <button
                 type="button"
                  onClick={AddNewItem}
                  className='buttonDesign'
                >
                  Add Material Field
                </button>
              </div>

            </div>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '10px',
                paddingLeft: '50px',
                 fontWeight: 'bold',
                backgroundColor: '#f8f9fa',
              }}>
                <p>label name</p>
                <p>new price</p>
                <p>old price</p>
                <p></p>
              </div>
            <div style={{ padding: '20px' }}>
              {addNewItem.map((field, index) => (
                <div key={index} className="AddNewUnitName">
                  <input
                    type="text"
                     className="AddNewUnitplace"
                    onChange={(e) => handleFieldchange(e.target.value, index, 'label')}
                    value={field.label}
                    placeholder={`Item Name ${index + 1}`}
                    aria-label={`Item Name ${index + 1}`}
                  />
                  <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 12,
                  }} >
                    <input
                     className="AddNewUnitplace"
                      type="number"
                      value={field.value}
                      onChange={(e) => handleFieldchange(e.target.value, index, 'value')}
                      placeholder={`Price ${index + 1}-new price`}
                      aria-label={`Price ${index + 1}`}
                    />
                    <input
                     className="AddNewUnitplace"
                      type="number"
                      value={field.oldvalue}
                      onChange={(e) => handleFieldchange(e.target.value, index, 'oldvalue')}
                      placeholder={`Price ${index + 1}-old price`}
                      aria-label={`Price ${index + 1}`}
                    />
                    <Button type="button" variant="danger" onClick={() => handleRemoveField(index)} >
                      <i class="bi bi-x-circle-fill"></i>
                    </Button>
                  </div>

                </div>
              ))}

            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button className='buttonDesign'  onClick={() => handleAddingRoomMaterial()}>save</button>
          <button className='buttonDesign'  onClick={() => setItemShow(false)}>Close</button>
        </Modal.Footer>
      </Modal>



      {/* Header Section */}
      <div className="adminHeader">
        <h2>Price List</h2>
      </div>

      {/* Sub-header with Add Room Button */}
      <div className="adminHeader1">
        <div>
          <h2>Price List</h2>
        </div>
        <div className="Header1button">
          <div>
          <button onClick={() => setItemShow(true)} className="buttonDesign">Add Item</button>
          </div>
          <div>
          <button  className="buttonDesign">Add Room</button>
          </div>
         
         
        </div>
      </div>
      <hr />

      {/* Room Data Display */}
      <div>
        {roomData.map((room, index) => (
          <div key={index} className="adminPriceList">
            <div>
              <h5>{room.name}</h5>
            </div>
            <div>

              <Link to={`/admin-dashboard/AdminPriceRoom`} state={{ roomData: room.data }}>
                <button className="buttonDesign">View Room</button>
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AdminPriceList;
